import {
    getAvailableSubscriptions,
    AvailableSubscriptionsResponseData,
} from '@yandex-int/k-common/client/api/defs/get-available-subscriptions';
import { putSubscribeCourse } from '@yandex-int/k-common/client/api/defs/put-subscribe-course';
import { CourseSubscriptionsData } from '@yandex-int/k-common/typings';
import { call, put, takeEvery, all, takeLatest } from 'redux-saga/effects';

import { courseSubscriptionsActions } from './actions';
import { getCourseSubscriptions } from './subscriptions-loader';

export function* subscriptionsSagasWatcher() {
    yield all([
        takeEvery(courseSubscriptionsActions.getSubscriptionsByCourse, getSubscriptionsByCourseSaga),
        takeLatest(courseSubscriptionsActions.getAvailableSubscriptionsRequest, getAvailableSubscriptionsSaga),
        takeLatest(courseSubscriptionsActions.subscribe, subscribeSaga),
    ]);
}

function* getSubscriptionsByCourseSaga(action: ReturnType<typeof courseSubscriptionsActions.getSubscriptionsByCourse>) {
    const { courseId } = action.payload;

    try {
        const subscriptions: CourseSubscriptionsData = yield call(getCourseSubscriptions, [courseId]);
        yield put(
            courseSubscriptionsActions.getSubscriptionsByCourseSuccess({
                courseId,
                subscriptions: subscriptions[courseId],
            })
        );
    } catch (error) {
        console.error(error);
        yield put(courseSubscriptionsActions.getSubscriptionsByCourseError({ courseId }));
    }
}

function* getAvailableSubscriptionsSaga(
    action: ReturnType<typeof courseSubscriptionsActions.getAvailableSubscriptionsRequest>
) {
    const { courseId, grade, subject } = action.payload;

    try {
        const responseData: AvailableSubscriptionsResponseData = yield call(getAvailableSubscriptions, {
            course_id: courseId,
            grades: [grade],
            subjects: [subject],
        });
        yield put(
            courseSubscriptionsActions.getAvailableSubscriptionsSuccess({
                courseId,
                subscriptions: responseData.results,
            })
        );
    } catch (error) {
        console.error(error);
        yield put(courseSubscriptionsActions.getAvailableSubscriptionsError({ courseId }));
    }
}

const MAX_RETRIES_COUNT = 3;
let retriesCount: Record<string, number> = {};

function* subscribeSaga(action: ReturnType<typeof courseSubscriptionsActions.subscribe>) {
    const { courseId, slug, onSuccess, onError } = action.payload;
    const key = `${slug}${courseId}`;

    try {
        yield call(putSubscribeCourse, { slug, target: { course_id: courseId } });
        yield put(courseSubscriptionsActions.getSubscriptionsByCourse({ courseId }));
        retriesCount[key] = 0;

        if (onSuccess) {
            onSuccess();
        }
    } catch (e) {
        console.error(e);

        let retriesCountBySlug = retriesCount[key] || 0;
        if (retriesCountBySlug < MAX_RETRIES_COUNT) {
            retriesCount[key] = retriesCountBySlug + 1;
            yield put(courseSubscriptionsActions.subscribe(action.payload));
        } else if (onError) {
            onError();
        }
    }
}
